export default "__VITE_ASSET__MVlqpjJr__"